import styled from 'styled-components';

export const SelectContainerLanguage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  /* position: fixed;
  top: 38px;
  right: 75px; */
  z-index: 15;
  height: auto;

  background-color: transparent;
  cursor: pointer;

  /* @media screen and (min-width: 1280px) {
    top: 56px;
    right: 350px;
  } */
`;

export const SelectLanguage = styled.select`
  width: auto;
  height: auto;
  border-radius: 5px;
  color: #000000;
  border-color: transparent;
  background: transparent;
  padding: 3px;
  cursor: pointer;

  font-family: 'Playfair Display', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.01em;
  text-decoration: none;
  transition: all 0.25s ease-in;

  @media screen and (min-width: 1280px) {
    font-size: 20px;
  }

  &:focus,
  &:hover,
  &:focus-visible {
    transform: scale(1.1);
  }
`;

export const LanguageDiv = styled.div`
  margin-right: 50px;
  @media screen and (min-width: 1280px) {
    margin-right: 0;
  }
`;
